import { useEffect, useRef, useState } from 'react';

export const ImgToBase64 = (props: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement> & { preload?: boolean }, HTMLImageElement>) => {
    const [src, setSrc] = useState(props.src);
    const isLoading = useRef(false);

    useEffect(() => {
        if (props.src == null) return;
        if (typeof fetchedData !== 'undefined' && fetchedData[props.src] != null) {
            setSrc(fetchedData[props.src]);
            return;
        }
        if (isLoading.current) return;
        isLoading.current = true;

        const imgEl = document.createElement('img');
        imgEl.onload = (ev) => {
            const img = ev.target as HTMLImageElement;
            if (img == null) return;
            const canvas = document.createElement('canvas');
            canvas.width  = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            if (ctx == null) return;
            ctx.drawImage(img, 0, 0);
            const dataURL = canvas.toDataURL('image/jpeg');
            setSrc(dataURL);

            const el = document.createElement('script')
            el.type = 'text/javascript'
            el.innerHTML = `
                window.fetchedData = window.fetchedData || {};
                fetchedData['${props.src}'] = '${dataURL}';
            `
            document.head.appendChild(el)
            isLoading.current = false;
        };
        imgEl.src = props.src
    }, [props.src])
    
    if (props.preload) {
        return null;
    }

    // eslint-disable-next-line jsx-a11y/alt-text
    return <img {...props} src={src} />
}
